
<div id="searchSection">
    <div class="searchContainer">

        <div class="searchCon2">
            <div class="search">
                <input id="search-box" (change)="searchDocs()" type="text">
                <a (click)="searchDocs()" href="javascript:void(0)"><i class="fa fas fa-search"></i></a>
            </div>
            <div class="d-block">
                <a class="searchAll" href="javascript:void(0)" (click)="openDocs()">
                    <span>See full list of legal agreements here</span>
                </a>
            </div> 
        </div>

        <!-- <div class="options" ngbDropDown>
            <a class="nav-link" id="dropdownBasic1" ngbDropdownToggle>
                <span class="username">{{permissionData?.FirstName | slice:0:1}}{{permissionData?.LastName | slice:0:1}}</span>
            </a>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                <button (click)="userProfile()" class="dropdown-item">Profile</button>
                <button (click)="logout()" class="dropdown-item">Logout</button>
            </div>
        </div> -->


        <div class="options" (click)="toggleOptions()">
            <div class="d-inline-block" (click)="toggleOptions()">
                <button id="dropdownDash" data-toggle="collapse" href="#optionsMenu">
                    <span class="username">{{permissionData?.FirstName | slice:0:1}}{{permissionData?.LastName | slice:0:1}}</span>
                </button>
            </div>    
            <div id="optionsMenu" class="collapse navbar-collapse">
                <ul class="navbar-nav mr-auto">
                    <li class="nav-item" (click)="userProfile()">Profile</li>
                    <li class="nav-item" *ngIf="clientAccess" (click)="clientSettings()">Client Settings</li>
                    <li class="nav-item dropdown dropleft" *ngIf="needClient" href="#accountMenu" 
                        data-toggle="collapse">
                        <a class="nav-link dropdown-toggle" data-toggle="dropdown" href="#">Change Accounts</a>
                        <ul class="dropdown-menu" id="accountMenu">
                            <li *ngFor="let c of clients" id="{{c.client.ID}}" (click)="changeClients(c.client.ID)">{{c.client.ClientName}}</li>
                        </ul>

                    </li>
                    <li class="nav-item" (click)="logout()">Log Out</li>
                </ul>
            </div>


        </div>


        <!-- <div class="options">
            <div ngbDropdown class="d-inline-block">
                    <button id="dropdownDash" ngbDropdownToggle>
                        <span class="username">{{permissionData?.FirstName | slice:0:1}}{{permissionData?.LastName | slice:0:1}}</span>
                    </button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                    <button ngbDropdownItem (click)="userProfile()">Profile</button>
                    <button ngbDropdownItem *ngIf="clientAccess" (click)="clientSetttings()">Client Settings</button>
                    <button ngbDropdownItem *ngIf="needClient" href="#client-list" data-toggle="collapse">Change Accounts</button>
                    <button ngbDropdownItem (click)="logout()">Log Out</button>
                </div>
                <div id="client-list" class="collapse">
                    <span>client 1</span>
                    <span>client 2</span>
                    <span>client 3</span>
                </div>
            </div>    
        </div> -->
    </div>
</div>
